import { createAsyncThunk } from '@reduxjs/toolkit';
// import { RootState } from '@castlery/shared-redux-store';
// import { selectProduct, selectVariant, type Product, type Variant } from '@castlery/modules-product-domain';
import { EVENTS_NAMES_MAP } from '../events-name';
import { gaTrack } from '../utils';
// import { selectedCurrentCustomer } from '@castlery/modules-user-domain';
import { EcEnv } from '@castlery/config';
import { getOriginalAmount, getProductsNeedTracking } from '../helpers';
import type { LineItem } from '@castlery/types';

/**
 * @description
 * @note GA event : Checkout
 * @scenario 1. This event is triggered when a user do checkout.
 */
export const trackCheckoutActionEvent = createAsyncThunk(
  'tracking/trackCheckoutActionEvent',
  async (
    payload: {
      checkoutStep: number;
      lineItems: LineItem[];
      itemTotal: string;
      assemblyPreference?: string;
      selectedServiceType?: string;
      paymentMethod?: string;
    },
    { rejectWithValue, fulfillWithValue }
  ) => {
    const { checkoutStep, lineItems, itemTotal, assemblyPreference, selectedServiceType, paymentMethod } = payload;
    if (!checkoutStep || !lineItems)
      return rejectWithValue('[Error]:[trackCheckoutActionEvent]checkoutStep or lineItems not found');

    if (checkoutStep === 5 && !paymentMethod)
      return rejectWithValue('[Error]:[trackCheckoutActionEvent]paymentMethod not found');

    const trackedLineItems = lineItems.filter((item) => !item.is_swatch);
    if (trackedLineItems?.length <= 0) return fulfillWithValue({ data: 'success' });

    let checkoutObj: {
      actionField: {
        step: number;
        option: string;
      };
      products?: ReturnType<typeof getProductsNeedTracking>;
      value?: string;
    } = {
      actionField: {
        step: checkoutStep,
        option: '',
      },
    };

    if (checkoutStep === 1) {
      const trackedProducts = getProductsNeedTracking(trackedLineItems);
      const originalValue = getOriginalAmount(itemTotal);
      checkoutObj = {
        ...checkoutObj,
        products: trackedProducts,
        value: originalValue,
      };
      //   todo : track click - capi
    }

    if (checkoutStep === 4) {
      if (EcEnv.NEXT_PUBLIC_COUNTRY === 'SG') {
        // checkoutObj.actionField.option = selectedAssemblyPreferences?.[0]?.slug || null;
        checkoutObj.actionField.option = assemblyPreference ?? '';
      } else {
        // checkoutObj.actionField.option = shipments?.[0]?.selected_service_type?.type || null;
        checkoutObj.actionField.option = selectedServiceType ?? '';
      }
    }

    if (checkoutStep === 5) {
      checkoutObj.actionField.option = paymentMethod ?? '';
    }

    const params = {
      event: EVENTS_NAMES_MAP.GA_CHECKOUT,
      ecommerce: {
        currencyCode: EcEnv.NEXT_PUBLIC_CURRENCY,
        checkout: checkoutObj,
      },
    };
    gaTrack(params);
    return fulfillWithValue({ data: 'success' });
  }
);
